<p-dialog [(visible)]="visible" [modal]="true" [draggable]="false" [resizable]="false" [style]="{width: '800px'}"
    header="{{titlePlatform}}" (onHide)="hideDialog()">

    <p-toast></p-toast>

    <div class="dialog-content">
        <!-- File Upload Step -->
        <div *ngIf="currentStep === 'upload'">
            <p>Upload a CSV file with your prospects' information.</p>

            <div class="campaign-sender-container" >
                
                @if(platform=='linkedin'){
                <h3 class="sender-title mb-2 p-0">Select Campaign Sender</h3>

                <p-select [options]="senders" [(ngModel)]="selectedSender" optionLabel="firstName"
                    placeholder="Choose who will send this campaign" [showClear]="false"
                    styleClass="w-full sender-select mb-3" panelStyleClass="sender-panel">

                    <!-- Custom selected value template -->
                    <ng-template pTemplate="selectedItem" let-selectedSender>
                        <div class="flex align-items-center gap-2" *ngIf="selectedSender">
                            <i class="pi pi-user text-gray-500"></i>
                            <div>
                                <div class="font-medium">{{ selectedSender.firstName }} {{ selectedSender.lastName }}
                                </div>
                                <div class="text-sm text-gray-500">{{ selectedSender.emailAddress }}</div>
                            </div>
                        </div>
                    </ng-template>

                    <!-- Custom select item template -->
                    <ng-template pTemplate="item" let-sender>
                        <div class="flex align-items-center gap-2 p-2">
                            <i class="pi pi-user text-gray-500 text-lg"></i>
                            <div>
                                <div class="font-medium text-gray-900"> {{ sender?.firstName }} {{ sender?.lastName }}
                                </div>
                                <div class="text-sm text-gray-500"> {{ sender.emailAddress }}</div>
                            </div>
                        </div>
                    </ng-template>
                </p-select>
                }
            </div>

            <div class="upload-area" (dragover)="onDragOver($event)" (drop)="onDrop($event)">

                <div class="upload-icon">
                    <i class="pi pi-cloud-upload"></i>
                </div>

                <div class="upload-text">
                    <span>Upload CSV File</span>
                    <p>Drag and drop your file here, or click to browse</p>
                </div>

                <input type="file" #fileInput style="display: none;" accept=".csv" (change)="onFileSelected($event)" />

                <div class="choose-file-wrapper">
                    <button pButton type="button" label="Choose File" class="p-button-outlined"
                        (click)="openFileBrowser()">
                    </button>
                    <span *ngIf="selectedFile; else noFileSelected">{{ selectedFile.name }}</span>
                    <ng-template #noFileSelected>
                        <span>No file chosen</span>
                    </ng-template>
                </div>
            </div>
        </div>

        <!-- Column Mapping Step -->
        <div *ngIf="currentStep === 'mapping'">
          
        
            <div class="mapping-header">
                <div class="alert alert-info">
                    <i class="pi pi-info-circle"></i>
                    <div class="alert-content">
                        <strong>Map your columns</strong>
                        <p>Please map the columns from your CSV file to the appropriate fields. Fields marked with * are
                            required.</p>
                    </div>
                </div>
            </div>
            <div class="form-field">
                <label for="listName">List Name</label>
                <input id="listName" type="text" pInputText [(ngModel)]="listName" class="w-full" placeholder="Enter a list name">
            </div>

            <div class="mapping-fields">
                <div *ngFor="let mapping of columnMappings" class="mapping-field">
                    <label [for]="mapping.field">
                        {{ mapping.field }}
                        <span *ngIf="mapping.required" class="required-indicator">*</span>
                    </label>
                    <p-dropdown [id]="mapping.field" [options]="csvHeaders" [(ngModel)]="mapping.selectedColumn"
                        placeholder="Select column" [style]="{'width': '100%'}" appendTo="body"
                        (onChange)="preparePreviewData()">
                    </p-dropdown>
                </div>
            </div>

            <div class="preview-section">
                <h3>Preview</h3>
                <p-table [value]="previewData" styleClass="preview-table">
                    <ng-template pTemplate="header">
                        <tr>
                            <th>Email</th>
                            <th>FirstName</th>
                            <th>LastName</th>
                            <th>Company</th>
                            <th>Position</th>
                            <th>Phone</th>
                            <th>LinkedIn</th>
                            <th>Website</th>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-rowData>
                        <tr>
                            <td>{{ rowData.Email }}</td>
                            <td>{{ rowData.FirstName }}</td>
                            <td>{{ rowData.LastName }}</td>
                            <td>{{ rowData.Company }}</td>
                            <td>{{ rowData.Position }}</td>
                            <td>{{ rowData.Phone }}</td>
                            <td>{{ rowData.LinkedIn }}</td>
                            <td>{{ rowData.Website }}</td>
                        </tr>
                    </ng-template>
                </p-table>

                <div *ngIf="totalRows > displayedRows" class="more-rows-indicator">
                    +{{ totalRows - displayedRows }} more rows
                </div>
            </div>
        </div>
    </div>

    <ng-template pTemplate="footer">
        <div class="dialog-footer">
            <div *ngIf="currentStep === 'upload'">
                <button pButton type="button" label="Browse" class="p-button-outlined" (click)="openFileBrowser()">
                </button>
            </div>
            <div *ngIf="currentStep === 'mapping'">
                <button pButton type="button" label="Back" class="p-button-outlined" (click)="onBack()">
                </button>
            </div>
            <div class="footer-right">
                <button pButton type="button" label="Cancel" class="p-button-text" (click)="hideDialog()">
                </button>
                <button *ngIf="currentStep === 'mapping'" pButton type="button" label="Import {{totalRows}} Prospects"
                    class="p-button-primary" [disabled]="!areRequiredFieldsMapped()" (click)="onImport()">
                </button>
            </div>
        </div>
    </ng-template>
</p-dialog>